import $ from "jquery";

$('.world_map__marker').on('mouseenter', function(){
  if($(this).hasClass('active')) {
    // $(this).removeClass('active');
  } else {
    $('.world_map__marker').removeClass('active')
    $(this).addClass('active');
  }
});

function activateCountry(index) {
  console.log(index);
  $('.world_map__list_detail_country').removeClass('active');
  $('.world_map__list_detail_country').eq(index).addClass('active');
}

$('.world_map__list_flags .flag').on('click', function(){
  var index = $(this).attr('data-index');
  activateCountry(index);
});

$('.location-popup-close').on('click', function(){
  $('.world_map__marker').removeClass('active');
});